export const CURRENT_SPACE = "CURRENT_SPACE";
